import React                from 'react';
import PropTypes            from 'prop-types';


// import usePartnersPage      from './usePartnersPage';
import Header               from '../../components/Header';
import Footer               from '../../components/Footer';
import AvailabilityBG       from '../../../assets/images/availability.jpg';
import AutomationsBG        from '../../../assets/images/automations.png';
import ResultsBG            from '../../../assets/images/results.png';


import styles               from './PartnersPage.styl';

function PartnersPage() {
    // const { className, children, ...rest } = props;

    // const introduction = useRef();

    // const refs = {
    //     introduction,
    //     informationColect,
    //     yourInformation
    // }

    // const {
    // handleScrollTo
    // } = usePartnersPage(refs);

    return  (
        <div
            className = {styles.PartnersPage}
        >
            <Header theme='light' />
            <div className={styles.content}>
                <h1 className={styles.title}>
                    Our Partners
                </h1>
                <div className={styles.partnerBlock}>
                    <img
                        src       = {AvailabilityBG}
                        className = {styles.partnerLogo}
                    />
                    <div className={styles.rightBlock}>
                        <h3 className={styles.partnerName}>
                        WeaveApps
                        </h3>
                        <h5 className={styles.partnerDescription}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </h5>
                    </div>
                </div>
                <div className={styles.partnerBlock}>
                    <img
                        src       = {AutomationsBG}
                        className = {styles.partnerLogo}
                    />
                    <div className={styles.rightBlock}>
                        <h3 className={styles.partnerName}>
                        Viragames
                        </h3>
                        <h5 className={styles.partnerDescription}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </h5>
                    </div>
                </div>
                <div className={styles.partnerBlock}>
                    <img
                        src       = {ResultsBG}
                        className = {styles.partnerLogo}
                    />
                    <div className={styles.rightBlock}>
                        <h3 className={styles.partnerName}>
                        Taproom
                        </h3>
                        <h5 className={styles.partnerDescription}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </h5>
                    </div>
                </div>
            </div>
            <Footer theme='light' />
        </div>
    );
}

PartnersPage.propTypes = {
    className : PropTypes.string
};

PartnersPage.defaultProps = {
    className : ''
};

export default PartnersPage;
